import { defineStore } from 'pinia';

import { api } from './api.js';
import { pinia } from './store.js';

// Остатки по платным источникам. Живут в сторе, а не в компоненте, ровно по
// той причине, по которой сюда переехало всё остальное: компонент умирает при
// уходе с вкладки, и вместе с ним умирали цифры, за которыми только что ходили
// в чужие API. Человек возвращался на вкладку и видел пустой экран с кнопкой,
// будто ничего и не запрашивал.
//
// Само ничего не грузится: за цифрами идут запросы наружу, и делать их на
// каждом открытии настроек — платить временем за то, на что чаще всего не
// смотрят. Поэтому кнопка, и рядом честная подпись, на какой момент данные.

export const useLimits = defineStore('limits', {
  state: () => ({
    sources: [],
    memory: [],
    at: '',          // когда спрашивали в последний раз
    loading: false,
    error: '',
  }),
  actions: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const data = await api.get('/api/limits');
        this.sources = data.sources || [];
        this.memory = data.memory || [];
        this.at = data.at;
      } catch (e) {
        this.error = e.message;
      } finally {
        this.loading = false;
      }
    },
  },
});

export const limits = useLimits(pinia);
